import { render, staticRenderFns } from "./MyLibDragLineTester.vue?vue&type=template&id=56bc06fc&scoped=true&"
import script from "./MyLibDragLineTester.vue?vue&type=script&lang=js&"
export * from "./MyLibDragLineTester.vue?vue&type=script&lang=js&"
import style0 from "./MyLibDragLineTester.vue?vue&type=style&index=0&id=56bc06fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc06fc",
  null
  
)

export default component.exports